import { mutatorAction } from "satcheljs";
import getListViewState from "../selectors/getListViewState";
import type TableView from "../store/schema/TableView";

/**
 * Focuses a row that Jump To found among the rows already loaded, without selecting it, and
 * records a new Jump To request so the list scrolls the row to the top.
 */
export const focusJumpToRowMutator: (tableView: TableView, rowKey: string) => void = mutatorAction("focusJumpToRowMutator", (tableView: TableView, rowKey: string): void => {
    const listViewState = getListViewState();
    listViewState.jumpToRowKey = rowKey;
    listViewState.jumpToRequestId++;
    tableView.focusedRowKey = rowKey;
    // A focused group header would otherwise keep the row from taking focus.
    tableView.headerToFocus = null;
    tableView.selectionAnchorRowKey = rowKey;
    tableView.multiSelectionAnchorRowKey = null;
});
